// ============================================================
// Datei: src/components/GuestRegistration.jsx
//
// Zweck:
// - Wrapper-Komponente für die Gastregistrierung
// - entscheidet automatisch zwischen Desktop und Mobile
// ============================================================

import React from "react";
import useMediaQuery from "../../hooks/useMediaQuery";

import GuestRegistrationDesktop from "./GuestRegistrationDesktop";
import GuestRegistrationMobile from "./GuestRegistrationMobile";

const GuestRegistration = ({ refreshGuestList, guests }) => {
	const isMobile = useMediaQuery("(max-width: 768px)");

	return isMobile ? (
		<GuestRegistrationMobile
			refreshGuestList={refreshGuestList}
			guests={guests}
		/>
	) : (
		<GuestRegistrationDesktop
			refreshGuestList={refreshGuestList}
			guests={guests}
		/>
	);
};

export default GuestRegistration;